import { FunctionComponent } from 'react'
import { WAutocomplete } from '@alice-health/wonderland-react'
// `import type`: importing values from wonderland breaks SSR.
import type { WAutocompleteCustomEvent } from '@alice-health/wonderland'
import { FilterItem } from '@/modules/accredited-establishments/api/types'
import { useAddressSearch } from '@/modules/accredited-establishments/components/Filters/hooks'

/**
 * Desktop location search. Mobile uses the slide panel instead. The field takes
 * an arbitrary address and queries the API on every keystroke.
 */
const LocationChip: FunctionComponent = () => {
  const { address, addresses, onChange, updateAddress } = useAddressSearch()

  /* `w-type` carries the native `InputEvent`, not the typed text. */
  const onType = (event: WAutocompleteCustomEvent<InputEvent>) => {
    const input = event.detail.target as HTMLInputElement

    onChange(input.value)
  }

  return (
    <WAutocomplete
      className='shrink-0 w-[250px]'
      placeholder='Busque por uma localização'
      items={addresses?.items || []}
      value={address}
      searchByKey='title'
      leadingIcon='icLocalPin'
      onWType={onType}
      onWSelect={event => updateAddress(event.detail as unknown as FilterItem)}
    />
  )
}

export { LocationChip }
